import { render, staticRenderFns } from "./EntityBadge.vue?vue&type=template&id=3046684c&scoped=true"
import script from "./EntityBadge.vue?vue&type=script&lang=js"
export * from "./EntityBadge.vue?vue&type=script&lang=js"
import style0 from "./EntityBadge.vue?vue&type=style&index=0&id=3046684c&prod&lang=pcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3046684c",
  null
  
)

export default component.exports